import { Injector } from '@angular/core';
import { setContext } from '@apollo/client/link/context';
import { Preferences } from '@capacitor/preferences';
import { StorageKeys } from '@core-interfaces/global';
import { AuthService } from '@infra-adapters/services/auth.service';

export function createAuthLink(injector: Injector) {
  return setContext(async (operation, { headers }) => {
    // La renovación misma pasa por este link: pedir un token válido ahí la
    // haría esperarse a sí misma. AuthService se resuelve en cada petición
    // porque depende de Apollo, que se construye junto con este link.
    const token =
      operation.operationName === 'RefreshToken'
        ? (await Preferences.get({ key: StorageKeys.session_token })).value
        : await injector.get(AuthService).getValidSessionToken();

    return {
      headers: {
        ...headers,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };
  });
}
